import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ig-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss'],
})
export class QrcodeComponent implements OnInit {
  ariaLabel: string = 'QR Code image with the event url';
  cssClass: string = 'center';
  colorDark: string = '#2e2e2e';
  colorLight: string = '#ffffffff';
  elementType: string = 'canvas';
  errorCorrectionLevel: string = 'M';
  imageSrc: string = 'https://iti-images.s3.amazonaws.com/imgs/iti-s.png';
  qrdata: string = window.location.href;
  title: string = 'QR Code';

  ngOnInit() {
    this.qrdata = window.location.href;
  }
}
